// src/context/ProtectedRoute.js
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ padding: 120, color: "#fff" }}>
        Chargement de la session…
      </div>
    );
  }
  //console.log("login    :", user);
  if (!user) {
    // redirige vers login, et on peut passer from pour retour après login
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
